import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { KELLY_UID } from '../config/youtubeStudio';

// Pages only Kelly sees for now (Website). Same uid check as YouTube Studio; everyone else goes to the dashboard.
export const isKelly = (uid) => uid === KELLY_UID;
export default function KellyOnly({ children }) {
  const { user } = useAuth();
  return isKelly(user?.uid) ? children : <Navigate to="/dashboard" replace />;
}
